export default [
  {
    name: 'specialDiseaseLibrary',
    path: 'specialDiseaseLibrary',
    component: () => import(/* webpackChunkName: 'specialDiseaseLibrary' */ '@/views/scientificTools/specialDiseaseLibrary/index.vue'),
    meta: { keepAlive: true },
  },
  {
    name: 'specialDiseaseLibraryDetail',
    path: 'specialDiseaseLibraryDetail',
    component: () => import(
      /* webpackChunkName: 'specialDiseaseLibraryDetail' */ '@/views/scientificTools/specialDiseaseLibrary/detail/index.vue'),
  },
  {
    name: 'specialDiseaseLibraryPatientList',
    path: 'specialDiseaseLibraryPatientList',
    component: () => import(
      /* webpackChunkName: 'specialDiseaseLibraryPatientList' */ '@/views/scientificTools/specialDiseaseLibrary/patientList/index.vue'),
    meta: { keepAlive: true },
  },
  {
    name: 'specialDiseaseLibraryPatientDetail',
    path: 'specialDiseaseLibraryPatientDetail',
    component: () => import(
      /* webpackChunkName: 'specialDiseaseLibraryPatientDetail' */ '@/views/scientificTools/specialDiseaseLibrary/patientDetails/index.vue'),
  },
  {
    name: 'specialDiseaseLibraryData',
    path: 'specialDiseaseLibraryData',
    component: () => import(
      /* webpackChunkName: 'specialDiseaseLibraryPatientData' */ '@/views/scientificTools/specialDiseaseLibrary/data/index.vue'),
  },
];
